import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, Mail, Phone, MapPin } from 'lucide-react';
import { mockData } from '../mock';

const Footer = () => {
  const { doula } = mockData;
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <Heart size={24} />
              <span className="logo-text">{doula.name}</span>
            </div>
            <p className="body-small footer-tagline">{doula.tagline}</p>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Quick Links</h4>
            <nav className="footer-nav">
              <Link to="/" className="footer-link">Home</Link>
              <Link to="/about" className="footer-link">About</Link>
              <Link to="/services" className="footer-link">Services</Link>
              <Link to="/blog" className="footer-link">Blog</Link>
              <Link to="/contact" className="footer-link">Contact</Link>
            </nav>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Get in Touch</h4>
            <div className="footer-contact">
              <a href={`tel:${doula.phone}`} className="footer-contact-item">
                <Phone size={16} />
                <span className="body-small">{doula.phone}</span>
              </a>
              <a href={`mailto:${doula.email}`} className="footer-contact-item">
                <Mail size={16} />
                <span className="body-small">{doula.email}</span>
              </a>
              <div className="footer-contact-item">
                <MapPin size={16} />
                <span className="body-small">{doula.location}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="caption">© {currentYear} {doula.name}. All rights reserved.</p>
          <p className="caption">Serving Black mothers with love, respect, and ancestral wisdom.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
